import { useEffect, useState } from 'react';
import { useMsal } from "@azure/msal-react";
import { getProjectList, getProject } from '../services/project.service';
import { errorHandler } from "../error";
import BaseSelectSearch from "./BaseSelectSearch";

export default function ProjectControl({ customerId = null, allowEmpty = false, readOnly = false, onChange, value }) {
    const { instance } = useMsal();
    const [val, setVal] = useState(null);
    const [disabled, setDisabled] = useState(readOnly);

    useEffect(() => {
        if (customerId) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }

        setVal(null);
        if (onChange) {
            onChange(null);
        }

    }, [customerId]);

    useEffect(() => {
        async function fetchData() {
            try {
                let result;
                if (value) {
                    result = await getProject(instance, value);
                }

                if (result) {
                    if (onChange) {
                        onChange(result.id);
                    }

                    if (!val) {
                        setVal({
                            value: result.id,
                            label: result.name,
                        });
                    }
                }
            } catch (error) {
                errorHandler(error);
            }
        }
        fetchData();
    }, [value])

    return (
        <BaseSelectSearch
            disabled={disabled}
            promise={getProjectList}
            valueField="id"
            labelField="name"
            value={val}
            filter={{ customerId, orderBy: [{ field: "name" }] }}
            placeholder="Välj Projekt..."
            className="form-control p-0"
            onChange={(e) => {
                setVal(e)
                if (onChange) {
                    onChange(e.value);
                }
            }}
            emptyOption={allowEmpty}
            includeInput
            dark
        />
    )
}
